{
    "title": "Upload Documents",
    "subtitle": "Almost there! The final step is to upload a photo of your documents",
    "driverslicensefront": "Driver's License (Front)",
    "driverslicenseback": "Driver's License (Back)",
    "nationalidfront": "National ID (Front)",
    "nationalidback": "National ID (Back)",
    "passport": "Passport",
    "proofofaddress": "Proof of Address"
}